import { ca } from '@cian/analytics';

export function trackTopHitsLinkClick(): void {
  ca('eventSite', {
    action: 'click_sopr',
    category: 'Listing',
    label: 'also_looking',
    name: 'oldevent',
    useLastProducts: true,
  });
}

export function trackTopHitsLinksShown(): void {
  ca('eventSite', {
    action: 'show_sopr',
    category: 'Listing',
    label: 'also_looking',
    name: 'oldevent',
    useLastProducts: true,
  });
}
